import { render } from "./collegeStudentdetails.vue?vue&type=template&id=34b50ef7&scoped=true"
import script from "./collegeStudentdetails.vue?vue&type=script&lang=js"
export * from "./collegeStudentdetails.vue?vue&type=script&lang=js"

import "./collegeStudentdetails.vue?vue&type=style&index=0&id=34b50ef7&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b50ef7"]])

export default __exports__